import type { FC } from 'react';

import type { Register } from '../../../types/helsenorge.helseregistre.internalapi.entities.entities';
import type { HNHelseregistreJS } from '../../../types/Resources';

import { filterItems, matchFilter, useFilter, type FilterMatchers } from '@helsenorge/designsystem-react/components/Filter';
import FilterResultCountAndSortWrapper from '@helsenorge/designsystem-react/components/Filter/FilterResultCountAndSortWrapper';
import Toggle from '@helsenorge/designsystem-react/components/Toggle';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

import RegisterListeComponent from '../registrelist/registerliste-component';

type RegistreFilterType = {
  digitaltInnsyn: boolean;
};

interface Props {
  registerliste?: Array<Register>;
  resources: HNHelseregistreJS;
}

const RegistreComponent: FC<Props> = ({ resources, registerliste }) => {
  const total = registerliste ? registerliste.length : 0;

  const filter = useFilter<RegistreFilterType>({ defaultValues: { digitaltInnsyn: isAuthorized() } });
  const filterMatchers: FilterMatchers<Register, RegistreFilterType> = {
    digitaltInnsyn: matchFilter.booleanToggle<Register>(m => m.hasDialog || !!m.innsynslenke),
  };
  const filteredRegisterliste = filterItems(registerliste ?? [], filter.filters, filterMatchers);
  const numRegistre = filteredRegisterliste ? filteredRegisterliste.length : 0;
  const numResultsText = numRegistre < total ? `${numRegistre} ${resources.filterRegistreAv} ` : '';
  return (
    <>
      {isAuthorized() && (
        <>
          <Toggle
            label={[
              {
                text: resources.filterDigitaltInnsyn,
                type: 'subdued',
              },
            ]}
            checked={filter.filters.digitaltInnsyn}
            onChange={() => filter.setFilter('digitaltInnsyn', !filter.filters.digitaltInnsyn)}
          />
          {<FilterResultCountAndSortWrapper resultCount={`${numResultsText}${total} ${resources.filterRegistreUnit}`} />}
        </>
      )}
      {filteredRegisterliste && filteredRegisterliste.length === 0 ? (
        <p>{resources.filterIngenRegistre}</p>
      ) : (
        <RegisterListeComponent registerliste={filteredRegisterliste ? filteredRegisterliste : []} resources={resources} />
      )}
    </>
  );
};

export default RegistreComponent;
